import {PushEvent} from '../utils/googleTagManager';

export default function analytics() {
  return next => action => {
    const {meta} = action;

    if (meta && meta !== 'undefined' && meta.analytics) {
      PushEvent(meta.analytics.type, meta.analytics.payload);
    }

    return next(action);
  };
}



// WEBPACK FOOTER //
// ./middleware/analytics.js